<template>
  <div class="content ">
    <div class="contact">
      <p class="title" :style="{ color: textColor }" id="title">{{ title }}</p>
      <div class="desc" :style="{ color: textColor }">
        <p v-for="(item, index) in desc" :key="index">
          <span>{{ item.text }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
      email: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[2];
      this.email = config.email;
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 10px 0;
  flex: 1;
  background-image: url("~@/assets/images/contact.png");
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  .contact {
    transform: translateX(-100%);
    .desc {
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>
